// extracted by mini-css-extract-plugin
module.exports = {"index":"index-module--index--2UCCW"};